import { Button } from '@/components/ui/button';
import { BACKEND_AUTH_ENDPOINTS } from '@/constants/auth';
import { STORAGE_KEYS } from '@/constants/storage';
import { useDrawerStore } from '@/stores/drawerStore';
import { trackEvent } from '@/utils/analytics';

/**
 * 認証前にフォームデータを sessionStorage に保存
 * ページリダイレクト後も入力内容を保持するため
 */
function saveFormDataBeforeAuth() {
  const formData = useDrawerStore.getState().formData;
  if (formData.websiteUrl) {
    sessionStorage.setItem(STORAGE_KEYS.PENDING_FORM_DATA, JSON.stringify(formData));
  }
}

/**
 * AuthSelectView
 * 未ログイン時の認証誘導画面
 * - 提案対象のURLを表示（disabled）
 * - ラクスルIDでログインボタン
 *
 * ボタンを押すとラクスル認証サーバーにリダイレクトされ、
 * 認証サーバー側でログイン/新規登録を行う。
 * 認証完了後、フロントエンドにリダイレクトされ、
 * ハーフモーダルが開いた状態で表示される。
 */
export function AuthSelectView() {
  const { formData } = useDrawerStore();

  // ラクスル認証サーバーへリダイレクト（ログイン）
  const handleLogin = () => {
    // GA4 イベント送信: ログインボタンクリック
    trackEvent('login_click', {
      website_url: formData.websiteUrl || undefined,
    });

    saveFormDataBeforeAuth();
    sessionStorage.setItem(STORAGE_KEYS.OAUTH_PENDING, 'true');
    window.location.href = BACKEND_AUTH_ENDPOINTS.authorize;
  };

  return (
    <>
      {/* Scrollable Content Area */}
      <div className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8 flex flex-col items-center justify-center">
        <div className="max-w-lg w-full text-center space-y-6 sm:space-y-8">
          {/* Heading */}
          <div className="space-y-3 sm:space-y-4">
            <h2 className="text-[#111827] text-2xl sm:text-[28px] lg:text-[32px] font-bold leading-tight">
              まずは無料で登録
            </h2>
            <p className="text-[#6B7280] text-sm sm:text-base leading-relaxed">
              作成した提案書は、ラクスルIDにご登録のメールアドレスへ送付します。
            </p>
          </div>

          {/* Primary CTA Button - Center */}
          <div className="space-y-3 sm:space-y-4">
            {/* Pre-button info */}
            <p className="text-[#6B7280] text-xs sm:text-sm leading-relaxed">
              はじめての方はこちら（無料・1分で登録完了）
            </p>

            <Button
              onClick={handleLogin}
              className="w-full bg-[#0052FF] hover:bg-[#0041CC] text-white rounded-lg transition-all shadow-lg text-base sm:text-lg font-bold h-12 sm:h-14"
            >
              新規登録 または ログイン
            </Button>

            {/* Confirmation Text */}
            <p className="text-[#9CA3AF] text-xs sm:text-sm break-all">
              提案対象のURL:{' '}
              <span className="text-[#6B7280]">
                {formData.websiteUrl || 'example.com'}
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
